import React from 'react'
import { LoadingCard, MsgSemRegistros } from '../../../../Components'
import { Card, CardBody, CardHeader, CardSubtitle, CardTitle } from '../styles'

// Moldura padrão dos gráficos do Dashboard: título, subtítulo, destaque à direita e estados de carga/vazio
export default function ChartCard({ title, subtitle, destaque, status, minHeight = 280, children }) {
  return (
    <Card>
      <CardHeader>
        <div>
          <CardTitle>{title}</CardTitle>
          {subtitle && <CardSubtitle>{subtitle}</CardSubtitle>}
        </div>
        {status === 'ok' && destaque}
      </CardHeader>
      <CardBody minHeight={minHeight}>
        {
          {
            loading: <LoadingCard isVisible={true} />,
            empty: <MsgSemRegistros message="Nenhum registro no período" />,
            ok: children,
          }[status]
        }
      </CardBody>
    </Card>
  )
}
